import React from 'react';
import Suspense from "./views/components/Suspense";
import keycloak from "./keycloak";
import {ReactKeycloakProvider} from "@react-keycloak/web";
import MainView from "./views/MainView";
import {useDispatch, useSelector} from "react-redux";
import {TokenState, setToken} from "./state/tokenSlice";
import {Config} from "./config/Config";
import {
    ApolloClient,
    InMemoryCache,
    ApolloLink,
    HttpLink
} from '@apollo/client'
import {ApolloProvider} from '@apollo/react-hooks';
import {
    QueryClient,
    QueryClientProvider
} from 'react-query'
import {BrowserRouter} from 'react-router-dom';
import {
    ChakraProvider,
    theme,
} from "@chakra-ui/react"


function App() {
    const token = useSelector<TokenState, string | undefined>(state => state.token)
    const dispatch = useDispatch()

    const settings: Config = require('./config/config.json');

    const tokensHandler = (tokens: any) => {
        dispatch(setToken(tokens.token))
    }

    // apollo client
    const httpLink = new HttpLink({
        uri: settings.apiPath,
    });

    const middlewareLink = new ApolloLink((operation, forward) => {
        operation.setContext({
            headers: {
                'Authorization': token ? `Bearer ${token}` : '',
                //'x-hasura-role': 'user',
            }
        });
        return forward(operation);
    });

    // use with apollo-client
    const link = middlewareLink.concat(httpLink);

    // clean __typename, but preserve cache update (better solution than addTypename: false
    const cleanTypeName = new ApolloLink((operation, forward) => {
        if (operation.variables) {
            const omitTypename = (key: string, value: any) => (key === '__typename' ? undefined : value);
            operation.variables = JSON.parse(JSON.stringify(operation.variables), omitTypename);
        }
        return forward(operation).map((data) => {
            return data;
        });
    });

    const cleanLink = cleanTypeName.concat(link)

    const client = new ApolloClient({
        link: cleanLink,
        cache: new InMemoryCache({
            //addTypename: false
        })
    });

    // Create a react-query client
    const queryClient = new QueryClient()

    return (
        <ChakraProvider theme={theme}>
            <ReactKeycloakProvider authClient={keycloak}
                                   initOptions={{onLoad: 'login-required'}}
                                   onTokens={tokensHandler}
                                   LoadingComponent={<Suspense/>}>
                <React.Suspense fallback={<Suspense/>}>
                    <ApolloProvider client={client}>
                        <QueryClientProvider client={queryClient}>
                            <BrowserRouter>
                                <MainView/>
                            </BrowserRouter>
                        </QueryClientProvider>
                    </ApolloProvider>
                </React.Suspense>
            </ReactKeycloakProvider>
        </ChakraProvider>
    );
}

export default App;
